import { ApolloError, useQuery } from '@apollo/client'
import ContractQueries from '../ContractQueries'
import { TargetBonusAndContractChangeQuery, TargetBonusAndContractChangeQueryVariables } from '../../../types'

export default (
  employeeId: string,
  year: number,
  includeAll = false,
): { data: TargetBonusAndContractChangeQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<TargetBonusAndContractChangeQuery, TargetBonusAndContractChangeQueryVariables>(
    ContractQueries.TargetBonusAndContractChange,
    {
      variables: {
        employeeId: employeeId,
        year: year,
        includeAll: includeAll,
      },
    },
  )

  return { data, error, loading }
}
